module.exports = __webpack_public_path__ + "static/media/coaching-congrats.254a36af.png";